// Product analytics (PostHog), browser only.
//
// Cookieless: nothing is stored on the visitor's device and PostHog derives visitor counts
// from a daily-rotating hash on its servers, so no cookie banner is needed. Session replay
// stays off. Requires "cookieless tracking" enabled in the PostHog project settings, or
// events are dropped.
//
// The token comes from a meta tag the layout renders only when POSTHOG_TOKEN is set
// (production). Without it, init and track are no-ops, so development and tests send nothing.
// Signups themselves are counted from the database; these events describe the funnel.
import posthog from 'posthog-js'

let enabled = false

export function initAnalytics() {
  const meta = (name: string) => document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content
  const token = meta('posthog-token')
  const host = meta('posthog-host')
  if (!token || !host) return

  posthog.init(token, {
    api_host: host,
    defaults: '2026-08-30',
    cookieless_mode: 'always',
    disable_session_recording: true,
    capture_exceptions: true,
  })
  enabled = true
}

export type AnalyticsEvent =
  | 'early_access_form_started'
  | 'early_access_validation_failed'
  | 'early_access_signed_up'
  | 'early_access_details_saved'
  | 'early_access_details_skipped'
  | 'faq_opened'
  | 'demo_tab_viewed'
  | 'pricing_plan_selected'
  | 'sample_workpaper_downloaded'

export function track(event: AnalyticsEvent, properties?: Record<string, unknown>) {
  if (enabled) posthog.capture(event, properties)
}
